import { CURRENCIES } from "@/data/brokers";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Rollovers occur Mon–Fri at 22:00 server time; triple swap on broker-specific weekday.
export function rolloverSchedule(days, tripleDay, start = new Date("2026-06-12T12:00:00Z")) {
  const events = [];
  const d = new Date(start);
  while (events.length < days) {
    d.setUTCDate(d.getUTCDate() + 1);
    const dow = d.getUTCDay();
    if (dow === 0 || dow === 6) continue;
    events.push({ date: new Date(d), day: DAYS[dow], multiplier: dow === tripleDay ? 3 : 1 });
  }
  return events;
}

export function calcHolding(broker, instrumentId, direction, lots, days, currency = "USD") {
  const raw = broker.swaps[instrumentId];
  if (!raw || broker.swapSource === "Unavailable") return { available: false };
  const fx = CURRENCIES.find((c) => c.id === currency).factor;
  const perLot = direction === "long" ? raw.long : raw.short;
  const daily = perLot * lots * fx;
  const schedule = rolloverSchedule(days, broker.tripleSwapDay);
  const multipliers = schedule.reduce((a, e) => a + e.multiplier, 0);
  return {
    available: true,
    daily,
    total: daily * multipliers,
    perLot,
    schedule,
    nights: multipliers,
    tripleDay: DAYS[broker.tripleSwapDay],
  };
}

const FRESHNESS = {
  "Live feed": { label: "Live", tone: "live" },
  "Daily snapshot": { label: "Daily snapshot", tone: "snapshot" },
  Delayed: { label: "Delayed", tone: "delayed" },
  Unavailable: { label: "Unavailable", tone: "na" },
  "Admin upload": { label: "Admin upload", tone: "snapshot" },
};

export const freshness = (source) =>
  FRESHNESS[source] || { label: source || "Unknown", tone: "na" };
